import { useIsFeatureFlagEnabled } from "../featureFlags/useIsFeatureFlagEnabled";
import { apiUrls } from "../utils/apiUrls";
import { apiUrlsV2 } from "../utils/apiUrlsV2";

export const useApiUrls = () => {
  const isV2Enabled = useIsFeatureFlagEnabled("backend-green-endpoints-client");
  return isV2Enabled ? apiUrlsV2 : apiUrls;
};
